import { all, takeEvery, takeLatest } from 'redux-saga/effects'
import {
  addParticipantToGroupAction,
  createNewChatAction,
  createNewGroupAction,
  exitGroupAction,
  fetchChatConfigAction,
  fetchChatsInformationAction,
  pauseChatAction,
  promoteAdminGroupAction,
  removeParticipantToGroupAction,
  resumeChatAction,
  setActiveChatAction,
  startChatAction,
  transferChatToOperatorAction,
  unPromoteAdminGroupAction,
  updateChatAction,
  updateChatFirebaseAction,
  updateGroupAction
} from './chat/actions'
import {
  fetchMoreChatsAction,
  loadChatsByStatusAction,
  loadMessagesByChatIdAction,
  readMessagesFromChatAction,
  watchChatsCountAction
} from './chat/handles'
import { fetchActiveDepartmentsAction, selectDepartmentAction } from './department/handles'
import { setDepartmentSaga } from './department/sagas/setDepartmentSaga'

import { cancelChatAction } from './chat/handles/cancelChatAction'
import { closeChatAction } from './chat/handles/closeChatAction'
import { finalCloseChatAction } from './chat/handles/finalCloseChatAction'
import { loadChatsBySearchAction } from './chat/handles/loadChatsBySearchAction'
import { loadMessagesByChatIdSaga, readMessagesFromChatSaga } from './chat/sagas'
import { cancelChatSaga } from './chat/sagas/cancelChatSaga'
import { closeChatSaga } from './chat/sagas/closeChatSaga'
import { createNewChatSaga } from './chat/sagas/createNewChatSaga'
import { fetchMoreChatsSaga } from './chat/sagas/fetchMoreChatsSaga'
import { finalCloseChatSaga } from './chat/sagas/finalCloseChatSaga'
import { loadChatsBySearchSaga } from './chat/sagas/loadChatsBySearchSaga'
import { loadChatsByStatusSaga } from './chat/sagas/loadChatsByStatusSaga'
import { updateChatFirebaseSaga } from './chat/sagas/updateChatFirebaseSaga'
import { fetchCategoriesByCompanyAction, fetchCompanyDetailsAction, setSelectedCompanyAction } from './company/handles'
import { setSelectedCompanySaga } from './company/sagas/setSelectedCompanySaga'
import { createContactAction, fetchContactsByCompanyAction, updateContactAction } from './contact/handles'
import { createContactSaga, updateContactSaga } from './contact/sagas'
import {
  createMessageAsync,
  fetchMessageTemplatesAction,
  fetchMoreMessagesAsync,
  fetchQuickReplyMessagesAction,
  reSendMessageAction
} from './message/actions'
import { createMessageSaga, deleteMessageSaga, editTextMessageSaga, fetchMoreMessagesSaga } from './message/sagas'
import { saveNewStickerAction } from './sticker/actions'
import { deleteStickerAction, getStickersAction } from './sticker/handles'

import { deleteStickerSaga } from './sticker/sagas/deleteStickerSaga'
import { getStickersSaga } from './sticker/sagas/getStickersSaga'

import { fetchCampaignByIdAction, fetchManyByCampaignIdsAction } from './campaign/handles'
import { fetchCampaignByIdSaga } from './campaign/sagas/fetchCampaignByIdSaga'
import { fetchManyByCampaignIdsSaga } from './campaign/sagas/fetchManyByCampaignIdsSaga'
import { customButtonCallAction } from './chat/handles/customButtonCallAction'
import { transferChatAction } from './chat/handles/transferChatAction'
import { addParticipantToGroupSaga } from './chat/sagas/addParticipantToGroupSaga'
import { createNewGroupSaga } from './chat/sagas/createNewGroupSaga'
import { customButtonCallSaga } from './chat/sagas/customButtonCallSaga'
import { exitGroupSaga } from './chat/sagas/exitGroupSaga'
import { fetchChatsInformationSaga } from './chat/sagas/fetchChatsInformationSaga'
import { handleUpdateChatSaga } from './chat/sagas/handleUpdateChatSaga'
import { pauseChatSaga } from './chat/sagas/pauseChatSaga'
import { promoteAdminGroupSaga } from './chat/sagas/promoteAdminGroupSaga'
import { removeParticipantToGroupSaga } from './chat/sagas/removeParticipantToGroupSaga'
import { resumeChatSaga } from './chat/sagas/resumeChatSaga'
import { startChatSaga } from './chat/sagas/startChatSaga'
import { transferChatSaga } from './chat/sagas/transferChatSaga'
import { transferChatToOperatorSaga } from './chat/sagas/transferChatToOperatorSaga'
import { unPromoteAdminGroupSaga } from './chat/sagas/unPromoteAdminGroupSaga'
import { updateGroupSaga } from './chat/sagas/updateGroupSaga'
import { watchChatsCountSaga } from './chat/sagas/watchChatsCountSaga'
import { fetchCategoriesByCompanySaga } from './company/sagas/fetchCategoriesByCompanySaga'
import { fetchCompanyDetailsSaga } from './company/sagas/fetchCompanyDetailsSaga'
import { fetchContactsByCompanySaga } from './contact/sagas/fetchContactsByCompanySaga'
import { fetchCustomButtonsByCompanyAction } from './custom-button/actions'
import { fetchCustomButtonsByCompanySaga } from './custom-button/sagas/fetchCustomButtonByCompanySaga'
import { fetchActiveDepartmentsSaga } from './department/sagas/fetchActiveDepartmentsSaga'
import {
  createLabelAction,
  deleteLabelAction,
  fetchLabelsByCompanyAndOperatorAction,
  updateLabelAction
} from './label/handles'
import { createLabelSaga } from './label/sagas/createLabelSaga'
import { deleteLabelSaga } from './label/sagas/deleteLabelSaga'
import { fetchLabelsByCompanyAndOperatorSaga } from './label/sagas/fetchLabelsByCompanyAndOperatorSaga'
import { updateLabelSaga } from './label/sagas/updateLabelSaga'
import { deleteMessageAction } from './message/handles/deleteMessageAction'
import { editTextMessageAction } from './message/handles/editTextMessageAction'
import { fetchMessageTemplatesSaga } from './message/sagas/fetchMessageTemplatesSaga'
import { fetchQuickReplyMessagesSaga } from './message/sagas/fetchQuickReplyMessagesSaga'
import { reSendMessageSaga } from './message/sagas/reSendMessageSaga'
import {
  createQuickReplyAction,
  deleteQuickReplyAction,
  fetchRepliesByCompanyAction,
  updateQuickReplyAction
} from './quickReply/actions'
import { createQuickReplySaga } from './quickReply/sagas/createQuickReplySaga'
import { deleteQuickReplySaga } from './quickReply/sagas/deleteQuickReplySaga'
import { fetchRepliesByCompanySaga } from './quickReply/sagas/fetchRepliesByCompanySaga'
import { updateQuickReplySaga } from './quickReply/sagas/updateQuickReplySaga'
import { saveNewStickerSaga } from './sticker/sagas/saveNewStickerSaga'
import {
  fetchOperatorsAction,
  fetchUserPermissionAction,
  resendTwoFactorCodeAsync,
  signInAsync,
  signOutAsync,
  updateUserAction,
  updateUserOnMainApiAction,
  verifyTwoFactorAsync
} from './user/actions'
import { fetchUserPermissionSaga } from './user/sagas/fetchUserPermissionSaga'
import { signInSaga } from './user/sagas/signInSaga'
import { signOutSaga } from './user/sagas/signOutSaga'
import { verifyTwoFactorSaga } from './user/sagas/verifyTwoFactorSaga'
import { resendTwoFactorCodeSaga } from './user/sagas/resendTwoFactorCodeSaga'
import { fetchOperatorsSaga } from './user/sagas/fetchOperatorsSaga'
import { fetchChatConfigSaga } from './chat/sagas/fetchChatConfigSaga'
import { setActiveChatSaga } from './chat/sagas/setActiveChatSaga'
import { updateUserSaga } from './user/sagas/updateUserSaga'
import { updateUserOnMainApiSaga } from './user/sagas/updateUserOnMainApiSaga'
import {
  createFollowupAction,
  updateFollowupAction,
  deleteFollowupAction,
  fetchFollowupsByOperatorAction
} from './followup/actions'
import { createFollowupSaga } from './followup/sagas/createFollowupSaga'
import { updateFollowupSaga } from './followup/sagas/updateFollowupSaga'
import { deleteFollowupSaga } from './followup/sagas/deleteFollowupSaga'
import { fetchFollowupsByOperatorSaga } from './followup/sagas/fetchFollowupsByOperatorSaga'

export default function* rootSaga() {
  return yield all([
    takeLatest(setSelectedCompanyAction.request, setSelectedCompanySaga),
    takeEvery(createContactAction.request, createContactSaga),
    takeLatest(signOutAsync.request, signOutSaga),
    takeEvery(signInAsync.request, signInSaga),
    takeLatest(verifyTwoFactorAsync.request, verifyTwoFactorSaga),
    takeLatest(resendTwoFactorCodeAsync.request, resendTwoFactorCodeSaga),
    takeEvery(loadChatsByStatusAction.request, loadChatsByStatusSaga),
    takeEvery(loadChatsBySearchAction.request, loadChatsBySearchSaga),
    takeEvery(fetchMoreChatsAction.request, fetchMoreChatsSaga),
    takeLatest(loadMessagesByChatIdAction.request, loadMessagesByChatIdSaga),
    takeLatest(fetchMoreMessagesAsync.request, fetchMoreMessagesSaga),
    takeLatest(readMessagesFromChatAction.request, readMessagesFromChatSaga),
    takeEvery(createMessageAsync.request, createMessageSaga),
    takeLatest(createNewChatAction.request, createNewChatSaga),
    takeLatest(deleteMessageAction.request, deleteMessageSaga),
    takeLatest(editTextMessageAction.request, editTextMessageSaga),
    takeLatest(closeChatAction.request, closeChatSaga),
    takeLatest(finalCloseChatAction.request, finalCloseChatSaga),
    takeLatest(cancelChatAction.request, cancelChatSaga),
    takeLatest(updateChatFirebaseAction.request, updateChatFirebaseSaga),
    takeLatest(saveNewStickerAction.request, saveNewStickerSaga),
    takeLatest(getStickersAction.request, getStickersSaga),
    takeLatest(deleteStickerAction.request, deleteStickerSaga),
    takeLatest(transferChatAction.request, transferChatSaga),
    takeLatest(transferChatToOperatorAction.request, transferChatToOperatorSaga),
    takeLatest(selectDepartmentAction.request, setDepartmentSaga),
    takeLatest(customButtonCallAction.request, customButtonCallSaga),
    takeLatest(watchChatsCountAction.request, watchChatsCountSaga),
    takeLatest(fetchMessageTemplatesAction.request, fetchMessageTemplatesSaga),
    takeLatest(reSendMessageAction.request, reSendMessageSaga),
    takeLatest(updateChatAction.request, handleUpdateChatSaga),
    takeLatest(fetchQuickReplyMessagesAction.request, fetchQuickReplyMessagesSaga),
    takeLatest(startChatAction.request, startChatSaga),
    takeLatest(pauseChatAction.request, pauseChatSaga),
    takeLatest(resumeChatAction.request, resumeChatSaga),
    takeLatest(createLabelAction.request, createLabelSaga),
    takeLatest(updateLabelAction.request, updateLabelSaga),
    takeLatest(deleteLabelAction.request, deleteLabelSaga),
    takeLatest(createQuickReplyAction.request, createQuickReplySaga),
    takeLatest(updateQuickReplyAction.request, updateQuickReplySaga),
    takeLatest(deleteQuickReplyAction.request, deleteQuickReplySaga),
    takeLatest(createNewGroupAction.request, createNewGroupSaga),
    takeLatest(exitGroupAction.request, exitGroupSaga),
    takeLatest(addParticipantToGroupAction.request, addParticipantToGroupSaga),
    takeLatest(removeParticipantToGroupAction.request, removeParticipantToGroupSaga),
    takeLatest(promoteAdminGroupAction.request, promoteAdminGroupSaga),
    takeLatest(unPromoteAdminGroupAction.request, unPromoteAdminGroupSaga),
    takeLatest(updateGroupAction.request, updateGroupSaga),
    takeLatest(updateContactAction.request, updateContactSaga),
    takeLatest(fetchManyByCampaignIdsAction.request, fetchManyByCampaignIdsSaga),
    takeLatest(fetchCampaignByIdAction.request, fetchCampaignByIdSaga),
    takeLatest(fetchCompanyDetailsAction.request, fetchCompanyDetailsSaga),
    takeLatest(fetchCategoriesByCompanyAction.request, fetchCategoriesByCompanySaga),
    takeLatest(fetchActiveDepartmentsAction.request, fetchActiveDepartmentsSaga),
    takeLatest(fetchContactsByCompanyAction.request, fetchContactsByCompanySaga),
    takeLatest(fetchCustomButtonsByCompanyAction.request, fetchCustomButtonsByCompanySaga),
    takeLatest(fetchUserPermissionAction.request, fetchUserPermissionSaga),
    takeLatest(fetchChatsInformationAction.request, fetchChatsInformationSaga),
    takeLatest(fetchLabelsByCompanyAndOperatorAction.request, fetchLabelsByCompanyAndOperatorSaga),
    takeLatest(fetchRepliesByCompanyAction.request, fetchRepliesByCompanySaga),
    takeLatest(fetchOperatorsAction.request, fetchOperatorsSaga),
    takeLatest(fetchChatConfigAction.request, fetchChatConfigSaga),
    takeLatest(setActiveChatAction.request, setActiveChatSaga),
    takeLatest(updateUserAction.request, updateUserSaga),
    takeLatest(updateUserOnMainApiAction.request, updateUserOnMainApiSaga),
    takeLatest(fetchFollowupsByOperatorAction.request, fetchFollowupsByOperatorSaga),
    takeLatest(createFollowupAction.request, createFollowupSaga),
    takeLatest(updateFollowupAction.request, updateFollowupSaga),
    takeLatest(deleteFollowupAction.request, deleteFollowupSaga)
  ])
}
